module.exports = __webpack_public_path__ + "static/media/FiguraChooseContent.a5785558.png";